import React from 'react'
import { FormattedMessage } from 'react-intl'

import { ButtonColor } from '../../../ui-lib/button'
import { SignUpProductRecButton } from '../../../item/cta-button/signup-product-recommendation'
import { useAIDetector } from '../ai-detector-context'
import styles from './ai-detector-mobile.module.scss'
import { OutputDetectedShape, OutputTitle, OutputAiDetected } from '../output-components'

interface AIDetectorMobileOutputProps {
  aiPercent: number | null
}

export const AIDetectorMobileOutput: React.FC<AIDetectorMobileOutputProps> = (props) => {
  const { aiPercent } = props
  const { outputRef } = useAIDetector()

  const hasAiPercent = aiPercent !== null

  return (
    <div className={styles.outputContainer} ref={outputRef}>
      {hasAiPercent && (
        <>
          <div className={styles.outputAIContent}>
            <OutputDetectedShape />
            <OutputTitle aiPercent={aiPercent} />
          </div>
          <OutputAiDetected aiPercent={aiPercent} />
          <SignUpProductRecButton
            className={styles.outputSignupButton}
            color={ButtonColor.WDK24PrimaryLightBg}
            text={
              aiPercent > 0 ? (
                <span>
                  <strong>
                    <FormattedMessage
                      id="phrase.getGrammarly"
                      description="Get Grammarly"
                      defaultMessage="Get Grammarly"
                    />
                  </strong>
                </span>
              ) : (
                <span>
                  <strong>
                    <FormattedMessage
                      id="phrase.getGrammarly"
                      description="Get Grammarly"
                      defaultMessage="Get Grammarly"
                    />
                  </strong>
                  &nbsp;
                  <FormattedMessage
                    id="phrase.itsFree"
                    description="Sign up prompt value prop"
                    defaultMessage="It's free"
                  />
                </span>
              )
            }
            showArrow
          />
        </>
      )}
    </div>
  )
}
